var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("reconciliation-step-template", {
    attrs: { nextStep: _vm.nextStep, previousStep: _vm.previousStep },
    on: {
      next: _vm.goToNextStep,
      previous: function($event) {
        return _vm.$emit("previous")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Débit")))]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Sélectionnez la colonne des débits")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step-container-table border-black" },
              [
                _c("table-selectable-columns", {
                  attrs: { lines: _vm.csv, max: 1 },
                  model: {
                    value: _vm.value.template.amount_debit.columns,
                    callback: function($$v) {
                      _vm.$set(_vm.value.template.amount_debit, "columns", $$v)
                    },
                    expression: "value.template.amount_debit.columns"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }